import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2024巴黎奥运会';
const baseUrl = '20240724BLAYH';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'block',
      name: `${baseUrl}-block`,
      component: () => import('./pages/Block.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'hot',
      name: `${baseUrl}-hot`,
      component: () => import('./pages/Hot.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'show',
      name: `${baseUrl}-show`,
      component: () => import('./pages/Show.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'court',
      name: `${baseUrl}-court`,
      component: () => import('./pages/Court.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'dialogue',
      name: `${baseUrl}-dialogue`,
      component: () => import('./pages/Dialogue.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'olympicTime',
      name: `${baseUrl}-olympicTime`,
      component: () => import('./pages/OlympicTime.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },    
    {
      path: 'goldTime',
      name: `${baseUrl}-goldTime`,
      component: () => import('./pages/GoldTime.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rank',
      name: `${baseUrl}-rank`,
      component: () => import('./pages/Rank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
